import { Cube } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import React from 'react'
import { classNames } from 'src/lib/utils/helpers'

const wrapperSizeMap = {
  sm: 'w-8 h-8',
  md: 'w-9 h-9',
  lg: 'w-10 h-10'
}

interface BxgyBadgeProps {
  label: 'X' | 'Y'
}

interface ProductIconProps {
  wrapperSize?: keyof typeof wrapperSizeMap
}

export const ProductIcon: React.FC<ProductIconProps> = ({ wrapperSize = 'sm' }) => {
  return (
    <div
      className={classNames(
        'p-2 border-1 border-zinc-100 rounded-xl relative flex items-center justify-center bg-white',
        wrapperSizeMap[wrapperSize]
      )}
    >
      <Icon IconComponent={Cube} size='sm' className='text-zinc-400' iconProps={{ weight: 'duotone' }} />
    </div>
  )
}

export const DiscountDivider = () => {
  return (
    <div className='h-6 flex items-center'>
      <div className='w-[1px] bg-zinc-200'></div>
    </div>
  )
}

export const AndBadge = () => {
  return <div className=' px-1 rounded-md text-text-xs-semibold text-zinc-500 border-1 border-zinc-200'>AND</div>
}

export const BxgyBadge: React.FC<BxgyBadgeProps> = ({ label }) => {
  return (
    <div className='flex justify-center bg-zinc-500 rounded-md w-5 h-5 items-center text-white text-text-xs-semibold'>
      {label}
    </div>
  )
}
